import { render, staticRenderFns } from "./DebitNoteCard.vue?vue&type=template&id=5fd46090&scoped=true"
import script from "./DebitNoteCard.vue?vue&type=script&lang=js"
export * from "./DebitNoteCard.vue?vue&type=script&lang=js"
import style0 from "./DebitNoteCard.vue?vue&type=style&index=0&id=5fd46090&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fd46090",
  null
  
)

export default component.exports